import clsx from 'clsx'
import {
  type ComponentPropsWithoutRef,
  type ForwardedRef,
  forwardRef,
} from 'react'

import { type FvButtonProps, Icon } from '@fv/client-components'

import { AdminTooltip } from './AdminTooltip'

export type AdminButtonProps = ComponentPropsWithoutRef<'button'> &
  Pick<FvButtonProps, 'icon' | 'loading' | 'transform'> & {
    noOutline?: boolean
    tooltip?: string
  }
export const AdminButton = forwardRef(
  (
    {
      children,
      className,
      tooltip,
      noOutline,
      loading,
      icon,
      transform,
      ...props
    }: AdminButtonProps,
    ref: ForwardedRef<HTMLButtonElement>,
  ) => (
    <button
      className={clsx('btn uppercase', className, {
        'btn-outline': !noOutline,
      })}
      type={props.type ?? 'button'}
      {...props}
      disabled={props.disabled || loading}
      ref={ref}
    >
      <AdminTooltip label={tooltip}>
        <span className="flex gap-2 items-center">
          {loading && <Icon icon="spinner" />}
          {icon && !loading && <Icon icon={icon} transform={transform} />}
          {children}
        </span>
      </AdminTooltip>
    </button>
  ),
)
